<template>
	<v-navigation-drawer
    v-model="drawer"
    fixed
    temporary
    color="white"
  >
 		<v-sheet color="warning" dark>
 			<v-list-item>
	      <v-list-item-content>
	        <v-img :src="require('@/assets/sii-imagotipo-blanco.svg')" contain/>
	      </v-list-item-content>
  		</v-list-item>
      <div class="mt-2 text-h6 text-center">
      	e-Boleta
      </div>
		</v-sheet>
 		<v-sheet color="grey" dark>
 			<v-list-item>
				<v-list-item-icon>
					<v-icon>
						account_circle
					</v-icon>
				</v-list-item-icon>
	      <v-list-item-content>
	        {{ currentUsername }}
	      </v-list-item-content>
  		</v-list-item>
		</v-sheet>
    <v-list
			dense
			nav
			class="pt-1 pb-0"
		>
			<v-list-item-group
				:value="currentItem"
				mandatory
				active-class="primary theme--dark"
				:key="`menu-lateral-${menuItems.length}`"
			>
				<v-list-item
					v-for="item in menuItems"
					:key="`menu-lateral-${item.go}`"
					link :dark="isItMyRoute(item.go)"
					@click="goto(item.go)"
					:disabled="$store.getters['usuario/isLoadingPermisos'] || isItMyRoute(item.go)"
				>
					<v-list-item-icon>
						<v-icon>{{ item.icon }}</v-icon>
					</v-list-item-icon>

					<v-list-item-content>
						<v-list-item-title>{{ item.text }}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list-item-group>
		</v-list>
		<template v-slot:append>
			<!-- Pie del drawer -->
			<v-sheet color="warning" :height="10" />
		</template>
  </v-navigation-drawer>
</template>
<script>

import { mapState } from 'vuex';

// TODO por remover ///////////////
import * as config from '@/config';
///////////////////////////////////


export default {
	name: 'MainNav',
	computed:{
		// TODO por remover ////////
		usuarioEsNotificador: function() {
			let vm = this;
			return config.USUARIOS_NOTIFICADORES.includes(vm.currentUsername);
		},
		////////////////////////////
		currentUsername: function() {
			let vm = this;
			return vm.$store.getters['usuario/usuario'];
		},
		menuItems(){
			let vm = this;
			return [
				{
					text: 'Emitir Boleta',
					icon: 'calculate',
					go: 'calculadora-botonera',
				},
				{
					text: 'Resumen de ventas diarias',
					icon: 'view_list',
					go: 'Reportes',
					permiso: 'reporte'
				},
				{
					text: 'Usuarios',
					icon: 'account_box',
					go: 'GestionUsuarios',
					permiso: 'usuarios'
				},
				{
					text: 'Contribuyente',
					icon: 'info',
					go: 'MantenedorContribuyente',
					permiso: 'admin'
				},
				{
					text: 'Administración',
					icon: 'account_box',
					go: 'AdminContribuyente',
					esAdmin(){
						
						return vm.usuarioEsNotificador
					}
				},
				{
					text: 'Notificaciones',
					icon: 'notifications',
					go: 'notificaciones-carga-masiva',
					esAdmin(){
						
						return vm.usuarioEsNotificador
					}
				},
				{
					text: 'Dispositivos Offline',
					icon: 'perm_device_information',
					go: 'DispositivosOffline'
				},
				{
					text: 'Mensajería',
					icon: 'message',
					go: 'ViewMensajeria'
				}
			].filter(m=>vm.tienePermisos(m));
			// TEST
			// SE DEBIO USAR FILTER PARA MOSTRAR LOS ITEMES
			// CORRECTAMENTE EPGM 21-09-21
		},
		showBar:{
			get(){

				return this.drawer || this.mini;
			},
			set(val){
				this.mini = val;
			}
		},
		currentItem:{
			get(){
				for( let i=0; i<this.menuItems.length; i++){
					if( this.isItMyRoute(this.menuItems[i].go) ){
						this.selectedItem = i;
						return i;
					}
				}
				return -1;
			},
			set(val){
				this.selectedItem = val;
			}
		},
		...mapState('empresas',['selected'])
	},
	props: {
	  mini: {
	    type: Boolean,
	    default: false,
	  }
	},
	data () {
		return {
			bottomNav: 1,
			drawer: false,
			selectedItem:0
		}
	},
	methods:{
		goto: function(routeName){
			
			if( !!routeName )
				this.$router.push({name: routeName});
		},
		tienePermisos: function(item){
			
			if( item.esAdmin != null ){
				return item.esAdmin();
			}

			let permisos = this.$store.getters['usuario/permisos'];
			// en caso de que la ruta no tenga permisos, se permite el acceso
			// y se muestra el item en el menu
			if( !item.permiso )	return true;

			if( this.$store.getters['usuario/esRepresentanteLegal'] )	return true;

			// se checkea que el usuario tenga permisos para la ruta
			for( let permiso of permisos ){
				if( item.permiso === permiso )
					return true;
			}

			return false;
		},
		isItMyRoute: function( routeName ){
			let currentRouteName = this.$route.name;
			return currentRouteName === routeName;
		},
		setCurrentMenuItem: function(){
			for( let i=0; i<this.menuItems.length; i++){
				if( this.isItMyRoute(this.menuItems[i].go) ){
					this.selectedItem = i;
				}
			}
		}
	},
	mounted() {
		
	},
	watch:{
		mini(){
			this.drawer = !this.drawer;
		},
		$route(to, from) {
			this.setCurrentMenuItem();
		},
		selected(){
			this.setCurrentMenuItem();
		}
	}
}
</script>

<style lang="css" scoped>
	.theme--dark{
		color: white !important;
	}
</style>